import React, { Component, Fragment } from 'react';
import { Button, Form, Grid, Header, Icon, Label, Loader, Popup, Table } from 'semantic-ui-react';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';
import AddExamRecognition from './AddExamRecognition';
import axios from 'axios';
import moment from 'moment';
import { fetchMarks } from '../../Lookups/util';

class RecognizedExams extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onButtonClick: false,
            addCourse: false,
            courses: [],
            loader: true,
            student: JSON.parse(localStorage.getItem('student')),
            newStudyProgram: JSON.parse(localStorage.getItem('newStudyProgram')),
            studyProgramSemesters: localStorage.getItem('studyProgramSemesters'),
            deletingRowId: false,
            settingPreviousCourseInformation: false,

            marks: [],
            markId: null,
        };

        this.getExamRecognition = this.getExamRecognition.bind(this);
        this.deleteExamRecognition = this.deleteExamRecognition.bind(this);
    }

    componentDidMount() {
        this.getExamRecognition();
        this.getMarks();
    }

    getMarks() {
        fetchMarks()
            .then(res => {
                this.setState({
                    marks: res.data.map(el => ({
                        key: el.id,
                        value: el.id,
                        text: el.displayName,
                    }))
                });
            });
    }

    handleConfirm = (id, optLock) => {
        if (this.state.deletingRowId === id) this.deleteExamRecognition(id, optLock);
        if (this.state.editingRowId === id) this.editExamRecognition(id, this.state.markId);
    };

    editExamRecognition = (examId, markId) => {
        this.setState({ loader: true });
        axios.put(`/student-study-program-exam-recognition/${examId}/mark/${markId}`)
            .then((res) => {
                this.setState({
                    loader: false,
                    editingRowId: null
                });
                toast('Uspješno ste ažurirali predmet!');
                this.getExamRecognition();
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Predmet nije ažuriran!');
            });
    };

    deleteExamRecognition(examId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: examId,
            optLock
        };
        axios.delete(`/student-study-program-exam-recognition/delete/${examId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false, deletingRowId: false });
                toast('Uspješno ste izbrisali predmet!');
                this.getExamRecognition();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Predmet nije izbrisan!');
            });
    }

    getExamRecognition() {
        if (!this.state.student.locked) {
            this.setState({ loader: true });
            axios.get(`/student-study-program-exam-recognition/${this.state.newStudyProgram.id}/`)
                .then(res => {
                    let courses = res.data;
                    this.setState({ courses, loader: false });
                });
        } else {
            this.setState({ loader: false });
        }
    }

    setPreviousCourseInformation(id, value) {
        this.setState({ settingPreviousCourseInformation: id });
        axios.put(`/student-study-program-exam-recognition/set-previous-course-information/${id}/${value ? 1 : 0}/`)
            .then(res => {
                this.getExamRecognition();
                this.setState({ settingPreviousCourseInformation: false });
                toast('Uspješno ste ažurirali informaciju o predmetu!');
            })
            .catch(err => {
                toast('Došlo je do greške!');
                this.setState({ settingPreviousCourseInformation: false });
            });
    }

    render() {
        return (
            <div>
                {!this.state.onButtonClick && !this.state.student.locked && this.state.newStudyProgram.semesterStudentStartsFrom !== null &&
                    <Button
                        floated="right"
                        icon
                        labelPosition="right"
                        color="blue"
                        size="small"
                        style={FiltersOnStyle}
                        onClick={() => { this.setState({ addCourse: true, onButtonClick: true }); window.scrollTo(0, 0); }}
                    ><Icon className="add" />
                        Dodavanje predmeta
                    </Button> }
                {!this.state.onButtonClick && <br />}

                {this.state.addCourse && <AddExamRecognition
                    getExamRecognition={this.getExamRecognition}
                    closeAddMode={() => this.setState({ addCourse: false, onButtonClick: false })}
                />}

                {(!this.state.student.locked) && <br/>}

                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.courses.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Predmet
                                        <Header.Subheader>{this.state.student.studyProgramName}</Header.Subheader>
                                    </Header.Content>
                                </Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Priznaje se kao
                                        <Header.Subheader>{this.state.newStudyProgram.studyProgramName}</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell>Semestar</Table.HeaderCell>
                                <Table.HeaderCell>Ocjena</Table.HeaderCell>
                                <Table.HeaderCell>Datum ocjene</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {this.state.courses.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {(index + 1)}.
                                </Table.Cell >
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="13">
                                                {el.previousCourseStudyProgram.courseBasic.name}
                                            </Grid.Column>
                                            <Grid.Column width="3" verticalAlign="middle" textAlign="right">
                                                {
                                                    <Popup
                                                        content={el.previousCourseInformation ? 'Za ovaj predmet prikazuju se podaci sa starog plana.' : 'Za ovaj predmet prikazuju se podaci sa novog plana.'}
                                                        hideOnScroll position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                icon="check"
                                                                size="tiny"
                                                                color={el.previousCourseInformation ? 'blue' : 'gray'}
                                                                loading={this.state.settingPreviousCourseInformation === el.id}
                                                                disabled={this.state.settingPreviousCourseInformation}
                                                                onClick={() => {
                                                                    if (!el.previousCourseInformation) {
                                                                        this.setPreviousCourseInformation(el.id, true);
                                                                    }
                                                                }}
                                                            />}
                                                    />
                                                }
                                                {/*<span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>*/}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Table.Cell>
                                {/*<Table.Cell verticalAlign="middle" colSpan="2">*/}
                                {/*    {el.previousCourseStudyProgram.courseBasic.name}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="13">
                                                {el.currentCourseStudyProgram !== null ? el.currentCourseStudyProgram.courseBasic.name : ''}
                                            </Grid.Column>
                                            <Grid.Column width="3" verticalAlign="middle" textAlign="right">
                                                {
                                                    <Popup
                                                        content={el.previousCourseInformation ? 'Za ovaj predmet prikazuju se podaci sa starog plana.' : 'Za ovaj predmet prikazuju se podaci sa novog plana.'}
                                                        hideOnScroll position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                icon="check"
                                                                size="tiny"
                                                                color={!el.previousCourseInformation ? 'blue' : 'gray'}
                                                                loading={this.state.settingPreviousCourseInformation === el.id}
                                                                disabled={this.state.settingPreviousCourseInformation}
                                                                onClick={() => {
                                                                    if (el.previousCourseInformation) {
                                                                        this.setPreviousCourseInformation(el.id, false);
                                                                    }
                                                                }}
                                                            />}
                                                    />
                                                }
                                                {/*<span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>*/}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Table.Cell>
                                {/*<Table.Cell verticalAlign="middle" colSpan="2">*/}
                                {/*    {el.currentCourseStudyProgram !== null ? el.currentCourseStudyProgram.courseBasic.name : ''}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell verticalAlign="middle">
                                    {el.studyProgramSemester.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {
                                        this.state.editingRowId === el.id
                                            ? <Form.Field required error={this.state.courseErr} width={2}>
                                                <Form.Dropdown
                                                    clearable
                                                    placeholder="Odaberite ocjenu"
                                                    value={this.state.markId}
                                                    onChange={(e, { value }) => this.setState({ markId: value })}
                                                    name="markId"
                                                    options={this.state.marks}
                                                    search
                                                    fluid
                                                    selection
                                                />
                                            </Form.Field>
                                            : el.mark.displayName
                                    }
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.date).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" >
                                    {this.state.deletingRowId === el.id || this.state.editingRowId === el.id ?
                                        <div>
                                            <Fragment>
                                                <Popup
                                                    content={'Potvrdi'}
                                                    position="top center"
                                                    trigger={<Button
                                                        circular
                                                        icon
                                                        size="tiny"
                                                        color="blue"
                                                        onClick={() => {
                                                            this.handleConfirm(el.id, el.optLock);
                                                        }}
                                                    >
                                                        <Icon name="check"/>
                                                    </Button>}/>
                                                <Popup
                                                    content={'Odustani'}
                                                    position="top center"
                                                    trigger={<Button
                                                        basic
                                                        circular
                                                        icon
                                                        size="tiny"
                                                        color="blue"
                                                        onClick={() => {
                                                            this.setState({
                                                                deletingRowId: null,
                                                                editingRowId: null
                                                            });
                                                        }}
                                                    >
                                                        <Icon name="close"/>
                                                    </Button>}/>
                                            </Fragment>
                                        </div>
                                        : <div>
                                            <Popup
                                                content="Uređivanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.student.locked}
                                                        basic="true"
                                                        circular
                                                        icon="pencil"
                                                        size="tiny"
                                                        color="green"
                                                        onClick={() => this.setState({
                                                            editingRowId: el.id,
                                                            markId: el.mark.id
                                                        })}
                                                    />}
                                            />
                                            <Popup
                                                content="Brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.student.locked}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="tiny"
                                                        color="red"
                                                        onClick={() => this.setState({ deletingRowId: el.id })}
                                                    />}
                                            />
                                        </div>}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : <p>Nema unesenih podataka o priznatim predmetima za ovog studenta.</p>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default RecognizedExams;



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/RecognizedExams.js